export default __webpack_public_path__ + "static/media/diploma-cartas-de-reemplazo.dcdc5367.png";